import { TransactionRecordCategoryEnum } from '../enums/transaction-record-category.enum';
import { TransactionTypeEnum } from '../enums/transaction-type.enum';

/** Customer-facing: sales invoices, credits, receipts, refunds, deposits */
const CUSTOMER_FACING_TYPES: TransactionTypeEnum[] = [
	TransactionTypeEnum.SALES_INVOICE,
	TransactionTypeEnum.SALES_CREDIT,
	TransactionTypeEnum.RECEIPT,
	TransactionTypeEnum.REFUND,
	TransactionTypeEnum.DEPOSIT,
];

/** Supplier-facing: purchase invoices, credits, payments, refunds */
const SUPPLIER_FACING_TYPES: TransactionTypeEnum[] = [
	TransactionTypeEnum.PURCHASE_INVOICE,
	TransactionTypeEnum.PURCHASE_CREDIT,
	TransactionTypeEnum.PAYMENT,
	TransactionTypeEnum.REFUND,
];

const ALL_TYPES = Object.values(TransactionTypeEnum);

/**
 * Returns transaction types allowed for the given record category.
 * RA, RR, Customer: SI, SC, RECEIPT, REFUND, DEPOSIT
 * VM, VRWC, Road Tax, Insurance, Supplier, Agent: PI, PC, PAYMENT, REFUND
 * Vehicle, Location: all types
 */
export function getAllowedTransactionTypesForCategory(
	recordCategory: TransactionRecordCategoryEnum | undefined | null,
): TransactionTypeEnum[] {
	if (!recordCategory) {
		return ALL_TYPES;
	}

	switch (recordCategory) {
		case TransactionRecordCategoryEnum.RENTAL_AGREEMENT:
		case TransactionRecordCategoryEnum.RENTAL_RESERVATION:
		case TransactionRecordCategoryEnum.CUSTOMER:
			return CUSTOMER_FACING_TYPES;
		case TransactionRecordCategoryEnum.VEHICLE_MAINTENANCE:
		case TransactionRecordCategoryEnum.VEHICLE_ROAD_WORTHY_CHECK:
		case TransactionRecordCategoryEnum.VEHICLE_ROAD_TAX:
		case TransactionRecordCategoryEnum.VEHICLE_INSURANCE:
		case TransactionRecordCategoryEnum.SUPPLIER:
		case TransactionRecordCategoryEnum.AGENT:
			return SUPPLIER_FACING_TYPES;
		case TransactionRecordCategoryEnum.VEHICLE:
		case TransactionRecordCategoryEnum.LOCATION:
			return ALL_TYPES;
		default:
			return ALL_TYPES;
	}
}
